import type { Locale } from '@autho/i18n';
import { formatMoney, isLocale } from '@autho/i18n';
import { useIntl } from 'react-intl';
import { cn } from './cn.ts';

/** Tabular, currency always shown, negatives in parentheses (Design Principles: Money). */
export function Money({
  amount,
  currency,
  className,
}: {
  amount: string | null;
  currency: string;
  className?: string;
}) {
  const { locale } = useIntl();
  if (amount === null) return <span className={cn('tabular-nums text-muted', className)}>–</span>;
  const negative = amount.trim().startsWith('-');
  return (
    <span className={cn('tabular-nums whitespace-nowrap', negative && 'text-danger', className)}>
      {formatMoney(amount, currency, (isLocale(locale) ? locale : 'en') as Locale)}
    </span>
  );
}
